import { createSelector } from 'reselect'

import {
  selectCurrentContactIsLoaded,
  selectCurrentContactIsOrWillBeLoading,
} from 'ducks/crm/contacts'
import { selectAllCustomFieldCategoriesIsLoading } from 'ducks/crm/customFieldCategories'
import { selectAllCustomFieldsIsLoading } from 'ducks/crm/customFields'

export const selectIsContactDetailsColumnLoading = createSelector(
  selectAllCustomFieldCategoriesIsLoading,
  selectAllCustomFieldsIsLoading,
  selectCurrentContactIsOrWillBeLoading,
  (categories, fields, contact) => categories || fields || contact
)

export const selectIsContactDetailsColumnLoaded = createSelector(
  selectAllCustomFieldCategoriesIsLoading,
  selectAllCustomFieldsIsLoading,
  selectCurrentContactIsLoaded,
  (categories, fields, contact) => !categories && !fields && contact
)
